import type { TranslationDict } from './en';

const fr: TranslationDict = {
  common: {
    appName: 'ZoningPal',
    language: 'Langue',
    english: 'English',
    french: 'Français',
    dismiss: 'Fermer',
    close: 'Fermer',
    home: 'Accueil',
    pricing: 'Tarifs',
    legal: 'Mentions légales',
    contact: 'Nous joindre',
    blog: 'Blogue',
    signIn: 'Connexion',
    account: 'Compte',
    overview: 'Aperçu',
    settings: 'Paramètres du compte',
    reports: 'Mes rapports',
    plansPricing: 'Forfaits et tarifs',
    logOut: 'Déconnexion',
    navigation: 'Navigation',
    tagline: 'Intelligence de zonage assistée par IA',
    goHomeAria: 'Aller à l’accueil ZoningPal',
    permitReview: 'Examen des permis',
  },
  home: {
    heroPermitCta: 'Essayer le prototype Examen des permis (gratuit)',
    accTitle: 'Prototype de conformité des permis de construire',
    accSubtitle:
      'ZoningPal est notre plateforme de production d’intelligence de zonage à Toronto. Examen des permis est notre prototype canadien gratuit d’ACC — prolongeant le même pipeline neuro-symbolique vers la vérification de dossiers de permis sensible au CNB pour les AHJ et les praticiens AEC.',
    accBullet1: 'Réception de dossiers 2D (PDF/CAO) + BIM/IFC',
    accBullet2: 'Règles JSON déterministes d’abord, puis constats assistés par IA',
    accBullet3: 'Résultats à quatre états : Conforme / Non conforme / Info N/D / Incertain',
    accBullet4: 'Humain dans la boucle : accepter / remplacer / escalader + piste d’audit',
    accBullet5: 'Interface EN/FR; règles CNB/CCQ en français prévues en phase 2',
    accBullet6: 'API ouverte + export CSV/PDF; plan de résidence des données au Canada en phase 2',
    accCta: 'Ouvrir la démo gratuite Examen des permis',
    accNote: 'Prototype de démonstration de subvention — aucun compte ni crédit requis.',
  },
  residency: {
    title: 'Résidence des données au Canada',
    body:
      'ZoningPal est exploité par une société canadienne. Ce prototype de subvention utilise actuellement des services infonuagiques tiers qui peuvent ne pas encore être situés au Canada.',
    phase2:
      'Plan de phase 2 : migrer vers la résidence des données au Canada (régions infonuagiques canadiennes et/ou Azure OpenAI au Canada, avec déploiement sur site optionnel pour les AHJ).',
  },
  permit: {
    title: 'Examen des permis',
    subtitle:
      'Téléversez un dossier de permis de construire — données de demande plus dessins 2D (PDF/CAO) et modèles BIM/IFC — pour un examen de conformité préliminaire neuro-symbolique. Les règles exécutables par machine s’appliquent d’abord; l’IA n’intervient que lorsque l’information est incomplète. Prototype gratuit pour démonstration de subvention — aucun compte ni crédit requis.',
    rulesetTitle: 'Jeu de règles déterministes',
    rulesetLoading: 'Chargement du jeu de règles exécutables…',
    rulesetUnavailable:
      'Manifeste du jeu de règles indisponible jusqu’au déploiement de l’API.',
    rulesetExecution: 'déterministe d’abord, puis IA',
    rulesetPhase2Prefix: 'Phase 2 :',
    rulesetNoteSuffix:
      'Des adaptateurs prévus pour les codes de construction numérisés du CNRC (XML/DITA, JSON-LD, RDF/TTL, RASE) seront configurés en phase 2 avec un essai d’intégration virtuel.',
    address: 'Adresse du projet',
    municipality: 'Municipalité',
    typology: 'Typologie du bâtiment (CNB Partie 3 / Partie 9)',
    typologySelect: 'Sélectionner…',
    typologyGroupPart9: 'Partie 9 — Habitations et petits bâtiments',
    typologyGroupPart3: 'Partie 3 — Bâtiments plus grands / complexes',
    typologyPart9House: 'Maison / logement unifamilial',
    typologyPart9Townhouse: 'Duplex, maison en rangée ou jumelée',
    typologyPart9Suite: 'Logement secondaire, ruelle ou pavillon de jardin',
    typologyPart9Small: 'Petit bâtiment (commercial / autre sous les limites Partie 9)',
    typologyPart3Residential: 'Résidentiel multi-logements (appartement / condo)',
    typologyPart3Assembly: 'Assemblée, affaires ou commerces',
    typologyPart3Care: 'Établissement de soins ou de traitement',
    typologyPart3Industrial: 'Industriel / à risque élevé',
    typologyPart3: 'Autre Partie 3 ou usage mixte',
    typologyOther: 'Autre / incertaine quant à la Partie applicable',
    typologyHelp:
      'La Partie 9 et la Partie 3 sont des divisions du Code national du bâtiment du Canada (CNB). La Partie 9 vise les habitations et petits bâtiments — souvent ≤3 étages et ≤600 m² d’aire de bâtiment. La Partie 3 vise les bâtiments plus grands ou complexes (protection contre l’incendie, sécurité des occupants, accessibilité), y compris la plupart des projets multi-logements et non résidentiels.',
    applicant: 'Demandeur / propriétaire',
    email: 'Courriel de contact',
    storeys: 'Nombre d’étages',
    storeysPlaceholder: 'ex. 2',
    storeysHint: 'Le filtrage Partie 9 utilise souvent ≤3 étages.',
    gfa: 'Aire de plancher brute',
    gfaUnit: 'm²',
    gfaPlaceholder: 'ex. 240',
    gfaHint:
      'Indiquez l’aire en mètres carrés (m²). Le filtrage Partie 9 utilise souvent ≤600 m².',
    proposedUse: 'Usage / occupation proposé(e)',
    notes: 'Notes additionnelles',
    files: 'Fichiers du dossier de permis',
    dropzone:
      'Déposez des fichiers PDF, CAO (DWG/DXF) ou BIM/IFC ici, ou cliquez pour parcourir',
    dropzoneHint: 'Jusqu’à {max} fichiers · 15 Mo chacun · PDF, IFC, DWG, DXF, RVT, TXT, CSV',
    remove: 'Retirer',
    submit: 'Soumettre le dossier (gratuit)',
    submitting: 'Examen en cours…',
    preparing: 'Préparation du dossier de permis…',
    running: 'Exécution des contrôles déterministes, puis constats assistés par IA…',
    complete:
      'Examen terminé — {count} constats (déterministes + IA). Prototype gratuit de subvention.',
    addressRequired: 'L’adresse du projet est obligatoire.',
    resultsTitle: 'Constats préliminaires de conformité',
    statusModel:
      'Modèle à 4 états : Conforme / Non conforme / Information non disponible / Incertain',
    requestId: 'ID de demande',
    classificationNotes: 'Notes de classification',
    typologyCardTitle: 'Classification typologique CNB',
    typologyCardEmpty:
      'Aucune typologie sélectionnée — la classification demeure information non disponible.',
    typologyCardPart9House:
      'Maison / logement unifamilial Partie 9 sélectionné. Filtrage orienté Partie 9 (heuristiques ≤3 étages / ≤600 m²).',
    typologyCardPart9Townhouse:
      'Duplex / maison en rangée Partie 9 sélectionné. Confirmer le nombre de logements et les règles locales de multiplex / zonage.',
    typologyCardPart9Suite:
      'Voie logement secondaire / ADU Partie 9 sélectionnée. Confirmer les dispositions relatives aux suites et le zonage local.',
    typologyCardPart9Small:
      'Voie petit bâtiment Partie 9 sélectionnée. Confirmer que le projet demeure dans les limites d’aire / d’étages de la Partie 9.',
    typologyCardPart3Residential:
      'Résidentiel multi-logements Partie 3 sélectionné. Confirmation de l’usage principal et de la sous-section 3.2.2. requise (humain dans la boucle).',
    typologyCardPart3Assembly:
      'Assemblée / affaires / commerces Partie 3 sélectionné. Le groupe d’occupation et les exigences 3.2.2. nécessitent une confirmation humaine.',
    typologyCardPart3Care:
      'Soins / traitement Partie 3 sélectionné. Exigence accrue de sécurité des occupants — escalader les éléments incertains.',
    typologyCardPart3Industrial:
      'Industriel / à risque élevé Partie 3 sélectionné. Confirmer la classification des risques et les dispositions Partie 3 applicables.',
    typologyCardPart3:
      'Partie 3 (autre / mixte) sélectionnée. Confirmation de l’usage principal / sous-section 3.2.2. requise (humain dans la boucle).',
    typologyCardOther:
      'Typologie incertaine — classification humaine Partie 3 vs Partie 9 requise.',
    bilingualNote:
      'L’interface bilingue est disponible dès maintenant. Les jeux de règles exécutables du Code national du bâtiment (français) ou du Code de construction du Québec sont un livrable de phase 2 (le CNRC peut fournir des échantillons en français après l’octroi).',
    hitlTitle: 'Examen avec humain dans la boucle',
    hitlHelp:
      'Flux pour l’agent du bâtiment : Accepter le résultat du système, Remplacer par une nouvelle détermination à 4 états avec note, ou Escalader les éléments incertains / santé-sécurité pour une évaluation au cas par cas. Les actions sont consignées dans la piste d’audit ci-dessous.',
    colStatus: 'État',
    colTopic: 'Sujet',
    colRationale: 'Justification',
    colCode: 'Référence au code',
    colSource: 'Source',
    colReviewer: 'Examinateur',
    sourceDeterministic: 'Déterministe',
    sourceAi: 'Assisté par IA',
    accept: 'Accepter',
    override: 'Remplacer',
    escalate: 'Escalader',
    change: 'Modifier',
    saveOverride: 'Enregistrer le remplacement',
    cancel: 'Annuler',
    newStatus: 'Nouvel état',
    overrideNote: 'Note de remplacement (obligatoire)',
    overridePlaceholder: 'Indiquez pourquoi le résultat du système est modifié…',
    overrideNoteRequired:
      'Ajoutez une courte note de remplacement pour {id} (requise pour l’auditabilité).',
    accepted: 'Accepté',
    overridden: 'Remplacé',
    escalated: 'Escaladé pour examen humain',
    acceptNote: 'Détermination du système acceptée',
    escalateNote: 'Escaladé pour évaluation humaine au cas par cas',
    was: 'Était',
    humanReviewed: 'Examen humain',
    auditTitle: 'Piste d’audit',
    auditEmpty:
      'Aucune action d’examinateur pour l’instant. Acceptez, remplacez ou escaladez un constat pour créer un enregistrement horodaté avec référence au code.',
    auditTime: 'Heure',
    auditFinding: 'Constat',
    auditAction: 'Action',
    auditChange: 'Changement d’état',
    auditNote: 'Note / réf. code',
    missingInfo: 'Information manquante',
    humanSteps: 'Étapes d’examen humain recommandées',
    exportCsv: 'Exporter CSV',
    exportPdf: 'Imprimer / PDF',
    meets: 'Conforme',
    does_not_meet: 'Non conforme',
    information_not_available: 'Information non disponible',
    uncertain: 'Incertain',
    countMeets: 'Conforme',
    countFail: 'Non conforme',
    countIna: 'Info N/D',
    countUncertain: 'Incertain',
    rules: 'règles',
    execution: 'exécution',
    flowTitle: 'Déroulement d’un examen',
    flow1: 'Règles déterministes',
    flow1Desc: 'Contrôles JSON exécutables d’abord',
    flow2: 'Assistance IA',
    flow2Desc: 'Complète seulement lorsque les faits manquent',
    flow3: 'Constats à 4 états',
    flow3Desc: 'Conforme / Non conforme / Info N/D / Incertain',
    flow4: 'Humain dans la boucle',
    flow4Desc: 'Accepter, remplacer ou escalader avec audit',
    flow5: 'Export',
    flow5Desc: 'Téléchargement CSV ou impression/PDF pour les AHJ',
    sampleLoad: 'Charger un dossier Partie 9 exemple',
    sampleLoaded: 'Dossier Partie 9 exemple chargé. Vérifiez le formulaire, puis soumettez (gratuit).',
    sampleRun: 'Charger l’exemple et lancer l’examen',
    apiTitle: 'API ouverte',
    apiHelp:
      'Accès programmatique pour interfaces personnalisées ou intégrations de permis électroniques des AHJ. Prototype gratuit — aucune authentification requise.',
    apiAnalyze: 'POST /api/permit-review/analyze',
    apiRuleset: 'GET /api/permit-review/ruleset',
    apiCopy: 'Copier curl',
    apiCopied: 'Copié',
  },
};

export default fr;
